import EMPTY_FILTRO from './emptyFiltro'

const EMPTY_FILTRO_PROCESSO_CENTRAL = (caixa) => {
  return {
    ...EMPTY_FILTRO(caixa),
    municipios: [],
    status: null
  }
}

export default EMPTY_FILTRO_PROCESSO_CENTRAL



// WEBPACK FOOTER //
// ./src/libs/models/filtro/emptyFiltroProcessoCentral.js